import type { Grade } from '@fishymeter/types';
import { cn } from '@/lib/utils';

const GRADE_COLOR: Record<Grade, string> = {
  A: 'bg-grade-a/10 text-grade-a',
  B: 'bg-grade-b/10 text-grade-b',
  C: 'bg-grade-c/10 text-grade-c',
  D: 'bg-grade-d/10 text-grade-d',
  F: 'bg-grade-f/10 text-grade-f',
};

const GRADE_LABEL: Record<Grade, string> = {
  A: 'Rare Catch',
  B: 'Fresh Catch',
  C: "Yesterday's Catch",
  D: 'Dead Fish',
  F: 'Rotten Fish',
};

const GRADE_EMOJI: Record<Grade, string> = {
  A: '🦞',
  B: '🐟',
  C: '🐠',
  D: '💀',
  F: '🤢',
};

const SIZE: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-3 py-1',
  lg: 'text-base px-4 py-1.5',
};

export interface FishBadgeProps {
  grade: Grade;
  size?: 'sm' | 'md' | 'lg';
  showGrade?: boolean;
  className?: string;
}

export function FishBadge({ grade, size = 'md', showGrade = true, className }: FishBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-semibold',
        GRADE_COLOR[grade],
        SIZE[size],
        className,
      )}
    >
      <span aria-hidden>{GRADE_EMOJI[grade]}</span>
      <span>{GRADE_LABEL[grade]}</span>
      {showGrade && <span className="opacity-70">· {grade}</span>}
    </span>
  );
}
